export const projects = [
	{
		img: 'https://gurdeep7.github.io/upgrad/images/slideshow1.jpg',
		title: 'Linkedin Clone',
		des: "Upgrade is the website where users can buy different educational courses. In this project we have cloned some important features of the website with backend integration. We used NodeJS runtime, Express framework and MongoDB as database",
		demo: '',
		live: 'https://gurdeep7.github.io/upgrad/html/index.html',
		gitHub: 'https://gurdeep7.github.io/upgrad/html/index.html',
		technologies: [ 'HTML', 'CSS', 'javaScript', 'MongoDb'],
	},
	{
		img: "https://assets.smallcase.com/images/smallcases/160/SCNM_0010.png",
		title: 'Smallcase Clone',
		des: 'Smallcase is the website where users can buy stocks and invest in it. Replication of Smallcase website along with authentication feature, where users can filter, see the details and invest in stocks.',
		demo: '',
		live: 'https://smallcase-clone.herokuapp.com/',
		gitHub: 'https://github.com/anandKmrSharma/smallcase',
		technologies: ['ExpressJs', 'MongoDB', 'HTML', 'CSS', 'javaScript'],
	}
];


